<admin-app-header></admin-app-header>

<div class="container-fluid admin-page">
    <div class="row header">
        <div class="col-8">
            <h2 class="mb-2">Cron Jobs & Functions</h2>
            <p class="text-muted">Scheduled background jobs and one-off admin functions</p>
        </div>
        <div class="col-4">
            <div class="form-group mt-2">
                <select [(ngModel)]="selectedCategory" class="form-control form-select">
                    <option *ngFor="let category of categories" [value]="category">
                        {{ category }}
                    </option>
                </select>
            </div>
        </div>
    </div>

    <div class="row">
        <div class="col-12">
            <div *ngIf="isEmulator" class="alert alert-info mb-4">
                <i class="fas fa-info-circle me-2"></i>
                <strong>Note:</strong> These endpoints trigger backend functions that run scheduled jobs, send emails, or perform data operations.
            </div>
            <div *ngIf="!isEmulator" class="alert alert-warning mb-4">
                <i class="fas fa-exclamation-triangle me-2"></i>
                <strong>Production Mode:</strong> Run buttons are disabled for cron <em>test</em> functions. One-off operations explicitly marked as production-safe (seeds, backfills, idempotent migrations) remain runnable. For other tests, use the <a routerLink="/admin/test-local">Test Local Functions</a> page on the emulator.
            </div>
        </div>
    </div>

    <div class="row">
        <div class="col-12">
            <div class="card">
                <div class="card-body p-0">
                    <div class="table-responsive">
                        <table class="table table-hover mb-0">
                            <thead class="table-light">
                                <tr>
                                    <th style="width: 30px">
                                        <i class="fas fa-tag"></i>
                                    </th>
                                    <th>Function Name</th>
                                    <th>Description</th>
                                    <th style="width: 120px">Category</th>
                                    <th style="width: 100px">Frequency</th>
                                    <th style="width: 250px">Schedule</th>
                                    <th style="width: 120px; text-align: center">Action</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr *ngFor="let route of filteredRoutes">
                                    <td class="text-center">
                                        <i class="fas {{ getCategoryIcon(route.category) }} text-muted"></i>
                                    </td>
                                    <td>
                                        <strong>{{ route.name }}</strong>
                                        <br />
                                        <code class="small text-muted">{{ route.endpoint }}</code>
                                    </td>
                                    <td class="text-muted small">{{ route.description }}</td>
                                    <td>
                                        <span class="badge bg-secondary">{{ route.category }}</span>
                                    </td>
                                    <td>
                                        <span
                                            class="badge"
                                            [ngClass]="{
                                                'bg-success': route.frequency === 'Daily',
                                                'bg-primary': route.frequency === 'Weekly' || route.frequency === 'Monthly',
                                                'bg-warning': route.frequency === 'Every 5 min',
                                                'bg-info': route.frequency === 'Hourly',
                                                'bg-secondary': route.frequency === 'Manual'
                                            }"
                                        >
                                            {{ route.frequency }}
                                        </span>
                                    </td>
                                    <td class="small text-muted">
                                        <i class="fas fa-clock me-1"></i>
                                        {{ route.schedule }}
                                    </td>
                                    <td class="text-center">
                                        <button
                                            *ngIf="route.hasTestCallable && (isEmulator || route.runOnProduction)"
                                            (click)="runTest(route)"
                                            [disabled]="route.isRunning"
                                            [ngClass]="!isEmulator && route.runOnProduction ? 'btn-warning' : 'btn-primary'"
                                            class="btn btn-sm"
                                            [title]="!isEmulator && route.runOnProduction ? 'Production-safe one-off run' : 'Run on emulator'"
                                        >
                                            <span *ngIf="route.isRunning" class="spinner-border spinner-border-sm me-1" role="status" aria-hidden="true"></span>
                                            <i *ngIf="!route.isRunning" class="fas fa-play me-1"></i>
                                            {{ route.isRunning ? 'Running...' : 'Run' }}
                                        </button>
                                        <span *ngIf="route.hasTestCallable && !isEmulator && !route.runOnProduction" class="badge bg-light text-muted" title="Only available on emulator">
                                            Emulator only
                                        </span>
                                        <span *ngIf="!route.hasTestCallable" class="badge bg-light text-muted" title="No test function available">
                                            No test
                                        </span>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
